import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import withStyles from '@material-ui/core/styles/withStyles'
import Card from '../Card/Card.jsx'
import CardBody from '../Card/CardBody.jsx'
import CardHeader from '../Card/CardHeader.jsx'
import Img from 'gatsby-image'
import {
  warningColor,
  dangerColor,
  successColor,
} from '../../assets/jss/material-kit-pro-react'

import imagesStyles from '../../assets/jss/material-kit-pro-react/imagesStyles.jsx'
import cardsStyle from '../../assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx'
import { cardTitle } from '../../assets/jss/material-kit-pro-react.jsx'
import sectionInterestedStyle from '../../assets/jss/material-kit-pro-react/views/blogPostsSections/sectionInterestedStyle.jsx'

const style = {
  ...imagesStyles,
  ...cardsStyle,
  ...sectionInterestedStyle,
  cardTitle,
}

class PostListing extends React.Component {
  getPostList() {
    const postList = []
    try {
      this.props.postEdges.forEach(postEdge => {
        postList.push({
          path: postEdge.node.fields.slug,
          category: postEdge.node.frontmatter.category,
          cover: postEdge.node.frontmatter.cover.childImageSharp.resolutions,
          title: postEdge.node.frontmatter.title,
          date: postEdge.node.fields.date,
          excerpt: postEdge.node.excerpt,
          timeToRead: postEdge.node.timeToRead,
        })
      })
      return postList
    } catch (error) {
      return `Error: ${error}`
    }
  }
  getCategoryColor(category) {
    switch (category) {
      case 'knowledge':
        return successColor
      case 'news':
        return dangerColor
      case 'blog':
        return warningColor
    }
  }
  render() {
    const { classes } = this.props
    const postList = this.getPostList()
    return (
      <PostGrid>
        {/* Your post list here. */
        postList.map(post => (
          <Card key={post.title} plain blog>
            <Link to={post.path}>
              <CardHeader plain image>
                <Img
                  className={classes.imgFluid}
                  resolutions={post.cover}
                  alt=""
                />
                {post.cover && (
                  <div
                    className={classes.coloredShadow}
                    style={{
                      backgroundImage: 'url(' + post.cover.base64 + ')',
                      opacity: '1',
                    }}
                  />
                )}
              </CardHeader>
            </Link>
            <CardBody plain>
              <Link to={`/categories/${post.category}/1`}>
                <PostCategory color={this.getCategoryColor(post.category)}>
                  {post.category}
                </PostCategory>
              </Link>
              <h4 className={classes.cardTitle}>
                <Link to={`/publication/${post.path}`}>{post.title}</Link>
              </h4>
              <p className={classes.description}>
                {post.excerpt}
                <Link to={`/publication/${post.path}`}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        ))}
      </PostGrid>
    )
  }
}

const PostCategory = styled.h6`
  color: ${p => p.color};
`

const PostGrid = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, ${p => p.theme.col(4)});
  grid-gap: ${p => p.theme.col()};

  @media screen and (max-width: 1440px) {
    width: 100%;
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media screen and (max-width: 1000px) {
    width: 100%;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
    padding: 0 ${p => p.theme.col()};
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: ${p => p.theme.col(22)};
  }
`

export default withStyles(style)(PostListing)



// WEBPACK FOOTER //
// ./src/components/PostListing/PostListing.jsx